module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('SgsRenderNotificationSuccess', {
    model: {
      value: (_vm.notificationSuccess),
      callback: function($$v) {
        _vm.notificationSuccess = $$v
      },
      expression: "notificationSuccess"
    }
  }), _vm._v(" "), _c('SgsRenderNotificationError', {
    model: {
      value: (_vm.notificationError),
      callback: function($$v) {
        _vm.notificationError = $$v
      },
      expression: "notificationError"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('SgsRenderErrorList', {
    attrs: {
      "fieldValue": _vm.instance.errors
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "instance",
    attrs: {
      "label-position": "top",
      "rules": _vm.rules,
      "model": _vm.instance
    }
  }, _vm._l((_vm.rowsToShow), function(row) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((row.cols), function(col) {
      return _c('div', {
        class: 'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width
      }, [_vm._l((col.fields), function(field) {
        return [(field.type != 'collapse') ? _c('SgsRender', {
          attrs: {
            "moduleType": "form",
            "type": field.type,
            "attr": field,
            "rules": _vm.rules,
            "fieldValue": _vm.instance[field.columnName],
            "formIdentifier": _vm.formIdentifier,
            "instance": _vm.instance
          },
          on: {
            "input": _vm.updateField,
            "actionLinkSelected": _vm.actionLinkSelected,
            "callBusinessRule": _vm.callBusinessRule
          }
        }) : _c('SgsRenderCollapse', {
          attrs: {
            "attr": field,
            "moduleType": "form"
          }
        }, _vm._l((field.rows), function(row) {
          return _c('div', {
            staticClass: "row"
          }, _vm._l((row.cols), function(col) {
            return _c('div', {
              class: 'col-xs-' + col.width + ' col-sm-' + col.width + ' col-md-' + col.width
            }, [_vm._l((col.fields), function(field) {
              return [(field.type != 'collapse') ? _c('SgsRender', {
                attrs: {
                  "moduleType": "form",
                  "type": field.type,
                  "attr": field,
                  "rules": _vm.rules,
                  "fieldValue": _vm.instance[field.columnName],
                  "formIdentifier": _vm.formIdentifier,
                  "instance": _vm.instance
                },
                on: {
                  "input": _vm.updateField,
                  "actionLinkSelected": _vm.actionLinkSelected,
                  "callBusinessRule": _vm.callBusinessRule
                }
              }) : _vm._e()]
            })], 2)
          }), 0)
        }), 0)]
      })], 2)
    }), 0)
  }), 0)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-008be568!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/module/components/ModuleDashboard.vue
// module id = 876
// module chunks = 2